module.exports = __webpack_public_path__ + "static/media/siya_dhokane.4660f0fe.jpg";